<script setup>
import MapContainer from "@/components/MapContainer.vue";

</script>

<template>
  <div id="home">
    <MapContainer />
  </div>
</template>

<style scoped>
#home{
  /*background-color: aqua;*/
  width: 100vw;
  height: 100vh;
}
</style>